export enum BundlerStatusTypeEnum {
    Unsupported = -2,
    Unknown = -1,
    Ok = 0,
    Blocked = 1,
    PaperNearEnd = 2,
    PaperFinished = 3
}

export function bundlerStatusEnumLabel(bundlerStatus: BundlerStatusTypeEnum): string {
    switch (bundlerStatus) {
        case BundlerStatusTypeEnum.Unsupported:
            return "enum.bundler_status.unsupported";
        case BundlerStatusTypeEnum.Ok:
            return "enum.bundler_status.ok";
        case BundlerStatusTypeEnum.Blocked:
            return "enum.bundler_status.blocked";
        case BundlerStatusTypeEnum.PaperNearEnd:
            return "enum.bundler_status.paperNearEnd";
        case BundlerStatusTypeEnum.PaperFinished:
            return "enum.bundler_status.paperFinished";
        default:
            return "common.unknown";
    }
}